// extracted by mini-css-extract-plugin
export default {"container":"LunchSection-module__container__Z0TV0","text":"LunchSection-module__text__Q5yzE"};